import counterReducer from './features/counterfeature';
import userReducer from './features/user.feature';
import authReducer from './features/auth.feature';
import quarterFeature from './features/quarter.feature';
import assestmentFeature from './features/assestment.feature';
import assestmentTitleFeature from './features/assestmentTitle.feature';
import assestmentTitleIndicatorFeature from './features/assestmentTitleIndicator.feature';
import assestmentOpinionFeature from './features/assestmentOpinion.feature';
import competencyFeature from './features/competency.feature';
import competecnyOpinionfeature from './features/competecnyOpinionfeature';
import userRoleFeature from './features/roleName.feature';
import userRoleName from './features/userRoleNames.feature';
import competencyTitleIndicatorFeature from './features/competencyTitleIndicator.feature'
import skillMatrix from './features/skillMatrix.feature'
import matrixOpinion from './features/matrixOpinion.feature'
import roleCompetencyRca from './features/RoleCompetencyRca.feature'
const rootReducer = {
    counter: counterReducer,
    user: userReducer,
    auth: authReducer,
    quarter: quarterFeature,
    assestment:assestmentFeature,
    assestmenttitle:assestmentTitleFeature,
    assestmenttitleindicator:assestmentTitleIndicatorFeature,
    assestmentOpinion:assestmentOpinionFeature,
    competency:competencyFeature,
    competencyOpinion:competecnyOpinionfeature,
    //competency:competencyFeature,
    userRole:userRoleFeature,
    userRoleName:userRoleName,
    competencytitleindicator:competencyTitleIndicatorFeature,
    skillmatrix:skillMatrix,
    matrixOpinion:matrixOpinion,
    roleCompetencyRca:roleCompetencyRca,
}
//assestmenttitleindicator:assestmentTitleIndicatorFeature, "StateName: FeatureVariableName"


export default rootReducer;  